export {
    commonProps
  }
  
  let dimensionProps = dealProps([
    { prop: "dt", label:"日期", sortable: 'custom', 'min-width': 120 },
    { prop: "weekofyear", label:"周", sortable: false,'min-width': 120 },
    { prop: "month", label:"月份", sortable: false,'min-width': 120 },
    { prop: "ssp_user_name", label:"账户名称", sortable: false,'min-width': 120 },
    { prop: "ssp_media_id", label:"媒体ID", sortable: false,'min-width': 120 },
    { prop: "ssp_media_name", label:"媒体名称", sortable: false,'min-width': 120 },
    { prop: "ad_zone_id", label:"广告位ID", sortable: false,'min-width': 120 },
    { prop: "ad_zone_name", label:"广告位名称", sortable: false,'min-width': 120 },
    { prop: "platform_name", label:"平台", sortable: false,'min-width': 120 },
    { prop: "raw_request_cnt", label:"请求数", sortable: 'custom', 'min-width': 120, formatter: floatFormatter },
    { prop: "delivered_request_cnt", label:"返回数", sortable: 'custom', 'min-width': 120, formatter: floatFormatter },
    { prop: "fill_rate", label:"填充率", 'min-width': 120},
    { prop: "charged_impression_cnt", label:"曝光数", sortable: false, 'min-width': 120, formatter: floatFormatter },
    { prop: "charged_click_cnt", label:"点击数", sortable: false, 'min-width': 120, formatter: floatFormatter },
    { prop: "click_rate", label:"点击率", 'min-width': 120},
    { prop: "ecpm", label:"ecpm", 'min-width': 120, formatter: floatFormatter },
    { prop: "cost", label:"预计收入", sortable: false, 'min-width': 120, formatter: floatFormatter, tip: "收入金额为预估值，可能会在每个月确认实际收入时进行调整" },
  ]);

  
  function floatFormatter(row, column, cellValue, index) {
    return cellValue == null || cellValue == 'NaN' || cellValue == 'Infinity' ? '-' :
      parseFloat(cellValue).toLocaleString('en-US');
  }
  
  function dealProps(props) {
    for (let cfg of props) {
      cfg.resizable = true;
      cfg.fixed = false
    }
    return props;
  }
  let commonProps = dimensionProps